import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const quickLinks = [
  { to: '/', label: '网站首页' },
  { to: '/search', label: '软件搜索' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系方式' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-800 text-primary-100">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="mb-4 flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-play-circle-fill text-2xl"></i>
            </span>
            <span className="text-base font-bold text-background-50">看片软件</span>
          </div>
          <p className="text-sm leading-relaxed text-primary-200">
            看片软件是专注影视播放类软件的推荐与下载平台，汇聚多款热门看片软件，帮助用户轻松找到高速稳定的观影工具。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">
            <a href="#footer-categories" className="cursor-pointer">软件分类</a>
          </h4>
          <ul id="footer-categories" className="flex flex-col gap-2.5">
            {categories.slice(0, 5).map((cat) => (
              <li key={cat.id}>
                <Link
                  to={`/category/${cat.id}`}
                  className="text-sm text-primary-200 transition-colors hover:text-accent-300"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">
            <a href="#footer-quick" className="cursor-pointer">快捷导航</a>
          </h4>
          <ul id="footer-quick" className="flex flex-col gap-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-primary-200 transition-colors hover:text-accent-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">
            <a href="#footer-contact" className="cursor-pointer">联系我们</a>
          </h4>
          <ul id="footer-contact" className="flex flex-col gap-2.5 text-sm text-primary-200">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i>support@kanpian-soft.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line"></i>工作日 9:00 - 18:00
            </li>
            <li className="flex items-center gap-3 pt-1">
              <a href="#footer-contact" aria-label="微博" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-700 text-primary-100 transition-colors hover:bg-accent-500 hover:text-foreground-950">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="#footer-contact" aria-label="微信" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-700 text-primary-100 transition-colors hover:bg-accent-500 hover:text-foreground-950">
                <i className="ri-wechat-fill"></i>
              </a>
              <a href="#footer-contact" aria-label="哔哩哔哩" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-700 text-primary-100 transition-colors hover:bg-accent-500 hover:text-foreground-950">
                <i className="ri-bilibili-fill"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-700">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 md:flex-row md:px-6">
          <p>© 2026 看片软件 · 影视播放软件下载平台 · 本站内容均为演示数据</p>
          <p className="flex items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-300">免责声明</Link>
            <Link to="/contact" className="transition-colors hover:text-accent-300">意见反馈</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}